import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';

type Response =
  | {
      data: void;
    }
  | {
      error: FetchBaseQueryError | SerializedError;
    };

export const rtkCallback = (response: Response, callBack: () => any) => {
  //@ts-ignore
  !response.error && callBack();
};
